import { PackStatus } from '../../types/pack';

const DAY_MS = 24 * 60 * 60 * 1000;
const DELETE_MIN_AGE_MS = 7 * DAY_MS;

export const formatPackSizeKb = (sizeBytes: number): string => {
  const kb = Math.round(sizeBytes / 1024);
  return `${kb} Kb`;
};

export const formatPackSizeDiffKb = (currentBytes: number, previousBytes: number): string | null => {
  if (previousBytes === 0 && currentBytes === 0) {
    return null;
  }

  const diffKb = Math.round((currentBytes - previousBytes) / 1024);
  if (diffKb === 0) {
    return '(0 Kb)';
  }

  const sign = diffKb > 0 ? '+' : '';
  return `(${sign}${diffKb} Kb)`;
};

export const formatRelativeDays = (date: Date): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const target = new Date(date);
  target.setHours(0, 0, 0, 0);

  const days = Math.round((today.getTime() - target.getTime()) / DAY_MS);
  if (days <= 0) {
    return 'today';
  }

  if (days === 1) {
    return '1 day ago';
  }

  return `${days} days ago`;
};

export const isPackDeletable = (status: PackStatus, lastDownloadDate: Date): boolean => {
  if (status !== PackStatus.Deprecated) {
    return false;
  }

  return Date.now() - lastDownloadDate.getTime() >= DELETE_MIN_AGE_MS;
};
